<template>
    <BaseWidget v-bind="$attrs" :widget="meta" :loading="loading">
        <div class="dw-ring-layout">
            <svg class="dw-ring-svg" viewBox="0 0 120 120">
                <circle cx="60" cy="60" r="50" fill="none" stroke="var(--bs-gray-300)" stroke-width="10" class="dw-ring-bg" />
                <circle cx="60" cy="60" r="50" fill="none" stroke="var(--bs-warning)" stroke-width="10"
                    :stroke-dasharray="dash" stroke-dashoffset="0" stroke-linecap="round" transform="rotate(-90 60 60)" />
                <text x="60" y="55" text-anchor="middle" fill="var(--bs-body-color)" font-size="22" font-weight="700">%{{ percent }}</text>
                <text x="60" y="72" text-anchor="middle" fill="var(--bs-gray-500)" font-size="11">{{ $t('common.dashboard.widgetLabels.ringOutstanding') }}</text>
            </svg>
            <div class="dw-ring-details">
                <div class="dw-ring-detail">
                    <span class="dw-ring-detail-lbl">{{ $t('common.dashboard.widgetLabels.invoiceCount') }}</span>
                    <span class="dw-ring-detail-val">{{ count }}</span>
                </div>
                <div class="dw-ring-detail-divider"></div>
                <div class="dw-ring-detail">
                    <span class="dw-ring-detail-lbl">{{ $t('common.dashboard.widgetLabels.totalAmount') }}</span>
                    <span class="dw-ring-detail-val" style="color: var(--bs-warning)">{{ totalFormatted }}</span>
                </div>
                <div class="dw-ring-detail-divider"></div>
                <div class="dw-ring-detail">
                    <span class="dw-ring-detail-lbl">{{ $t('common.dashboard.widgetLabels.remaining') }}</span>
                    <span class="dw-ring-detail-val" style="color: var(--bs-danger)">{{ remainingFormatted }}</span>
                </div>
            </div>
        </div>
    </BaseWidget>
</template>

<script>
import BaseWidget from '../BaseWidget.vue';
import widgetMixin from '../widgetMixin';

export const meta = {
    id: 'outstanding',
    titleKey: 'common.dashboard.widgetTitles.outstanding',
    icon: 'bi-receipt',
    accent: 'var(--bs-warning)',
    accentBg: 'rgba(var(--bs-warning-rgb, 255, 199, 0), 0.12)',
    glassRgb: '255, 199, 0',
    defaultCol: 1,
    defaultRow: 1,
    source: { type: 'statistics', key: 'outstanding' },
};

function fmt(n) {
    return (parseFloat(n) || 0).toLocaleString('tr-TR', { style: 'currency', currency: 'TRY', maximumFractionDigits: 0 });
}

export default {
    name: 'OutstandingWidget',
    components: { BaseWidget },
    mixins: [widgetMixin],
    data() {
        return { meta };
    },
    computed: {
        count() { return this.apiData?.count ?? 0; },
        totalFormatted() { return fmt(this.apiData?.total_amount); },
        remainingFormatted() { return fmt(this.apiData?.total_remaining); },
        percent() {
            const total = parseFloat(this.apiData?.total_amount) || 0;
            const remaining = parseFloat(this.apiData?.total_remaining) || 0;
            if (total <= 0) return 0;
            return Math.round(((total - remaining) / total) * 100);
        },
        dash() {
            const circ = 2 * Math.PI * 50;
            const filled = circ * (this.percent / 100);
            return `${filled} ${circ - filled}`;
        },
    },
};
</script>
